import { renderSvg } from './renderSvg'

const SocialSvgIcon = ({ name, size, color }) => renderSvg(name, size, color)

export default SocialSvgIcon
